// Base URL of the google-photos-api backend.
//
// Set REACT_APP_API_URL to point the app at a different backend:
//   .env.development  -> http://localhost:5000   (local testing)
//   .env.production   -> https://<your-service>.onrender.com
//
// Create React App inlines this at build time, so a rebuild is required
// after changing it.
export const API_BASE = (
  process.env.REACT_APP_API_URL || "http://localhost:5000"
).replace(/\/$/, "");

export default API_BASE;
